import $Event from "./event"


export type EventTypes = {
    CONSULT_POPUP: boolean,
    GOANCHOR: string

}
const $bus = new $Event<EventTypes>()
export default $bus